// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keyValue__IakwxKCnMQ{padding-left:0;background-color:unset}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/messages/CustomFormSubmissionRow.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,sBAAA","sourcesContent":[".keyValue {\n  padding-left: 0;\n  background-color: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyValue": `keyValue__IakwxKCnMQ`
};
export default ___CSS_LOADER_EXPORT___;
